import React from "react";

/* 활성 상태는 굵은 스트로크로 표현 — fill 전환은 경로에 따라 형태가 뭉개져 사용하지 않음 */
const strokeProps = (active) => ({
  width: 22, height: 22, viewBox: "0 0 24 24", fill: "none",
  stroke: "currentColor", strokeWidth: active ? 2.5 : 1.8,
  strokeLinecap: "round", strokeLinejoin: "round",
});

const ICONS = {
  home: (active) => (
    <svg {...strokeProps(active)}>
      <path d="M3 10.5L12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1v-9.5z" />
    </svg>
  ),
  trips: (active) => (
    <svg {...strokeProps(active)}>
      <path d="M9 20l-5.5-2.2V5.3L9 7.5l6-3 5.5 2.2v12.5L15 17l-6 3z" />
      <path d="M9 7.5V20" /><path d="M15 4.5V17" />
    </svg>
  ),
  feed: (active) => (
    <svg {...strokeProps(active)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3.5 9h17M3.5 15h17" />
      <path d="M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
    </svg>
  ),
  rank: (active) => (
    <svg {...strokeProps(active)}>
      <path d="M8 21h8M12 17v4M17 4H7v6a5 5 0 0 0 10 0V4z" />
      <path d="M17 5h3a1 1 0 0 1 1 1c0 2.5-2 4.5-4 4.5M7 5H4a1 1 0 0 0-1 1c0 2.5 2 4.5 4 4.5" />
    </svg>
  ),
  me: (active) => (
    <svg {...strokeProps(active)}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" />
    </svg>
  ),
};

/* 하단 고정 탭 내비게이션 — 5탭 (홈 / 내 여행 / 커뮤니티 / 랭킹 / 내 정보) */
export default function BottomNav({ step, lang, onNav }) {
  const TABS = [
    { key: "intro",     icon: "home",  ko: "홈",      en: "Home",  match: ["intro", "login", "personal", "travel", "generating", "result", "review"] },
    { key: "mytrip",    icon: "trips", ko: "내 여행",  en: "Trips", match: ["mytrip"] },
    { key: "community", icon: "feed",  ko: "커뮤니티", en: "Feed",  match: ["community", "reviews_feed"] },
    { key: "ranking",   icon: "rank",  ko: "랭킹",    en: "Rank",  match: ["ranking"] },
    { key: "myinfo",    icon: "me",    ko: "내 정보",  en: "Me",    match: ["myinfo"] },
  ];

  return (
    <nav className="bottom-nav" aria-label="주요 메뉴">
      <div className="bottom-nav-inner">
        {TABS.map((tab) => {
          const active = tab.match.includes(step);
          return (
            <button
              key={tab.key}
              onClick={() => onNav(tab.key)}
              className="bottom-nav-tab"
              style={{
                color: active ? "var(--accent)" : "var(--nav-muted)",
              }}
              aria-current={active ? "page" : undefined}
            >
              <div style={{
                height: 3, width: 18, borderRadius: 2, marginBottom: 4,
                background: active ? "linear-gradient(90deg,#6366F1,#8B5CF6)" : "transparent",
                transition: "background 0.25s",
              }} />
              {ICONS[tab.icon](active)}
              <span className="text-xs" style={{ fontWeight: active ? 800 : 600, marginTop: 3 }}>
                {lang === "ko" ? tab.ko : tab.en}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
